// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import BarcodeScannerController from "./barcode_scanner_controller"
application.register("barcode-scanner", BarcodeScannerController)

import BarcodeToolController from "./barcode_tool_controller"
application.register("barcode-tool", BarcodeToolController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)

import ColumnMappingController from "./column_mapping_controller"
application.register("column-mapping", ColumnMappingController)

import ColumnToggleController from "./column_toggle_controller"
application.register("column-toggle", ColumnToggleController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import ContactWizardController from "./contact_wizard_controller"
application.register("contact-wizard", ContactWizardController)

import CustomerPinningController from "./customer_pinning_controller"
application.register("customer-pinning", CustomerPinningController)

import CustomerSelectorController from "./customer_selector_controller"
application.register("customer-selector", CustomerSelectorController)

import DashboardReorderController from "./dashboard_reorder_controller"
application.register("dashboard-reorder", DashboardReorderController)

import DesignV2Controller from "./design_v2_controller"
application.register("design-v2", DesignV2Controller)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownFilterController from "./dropdown_filter_controller"
application.register("dropdown-filter", DropdownFilterController)

import DynamicAddressController from "./dynamic_address_controller"
application.register("dynamic-address", DynamicAddressController)

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import FeatureHighlightController from "./feature_highlight_controller"
application.register("feature-highlight", FeatureHighlightController)

import ForceFulfillController from "./force_fulfill_controller"
application.register("force-fulfill", ForceFulfillController)

import FulfillmentSuggesterController from "./fulfillment_suggester_controller"
application.register("fulfillment-suggester", FulfillmentSuggesterController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import ImageEditorController from "./image_editor_controller"
application.register("image-editor", ImageEditorController)

import ImageSortableController from "./image_sortable_controller"
application.register("image-sortable", ImageSortableController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import InventoryQuickAddController from "./inventory_quick_add_controller"
application.register("inventory-quick-add", InventoryQuickAddController)

import InvoiceFormController from "./invoice_form_controller"
application.register("invoice-form", InvoiceFormController)

import KanbanController from "./kanban_controller"
application.register("kanban", KanbanController)

import LearnedTermRowController from "./learned_term_row_controller"
application.register("learned-term-row", LearnedTermRowController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OrderPricingController from "./order_pricing_controller"
application.register("order-pricing", OrderPricingController)

import OtherToggleController from "./other_toggle_controller"
application.register("other-toggle", OtherToggleController)

import PackingEditorController from "./packing_editor_controller"
application.register("packing-editor", PackingEditorController)

import PaymentGatewayFormController from "./payment_gateway_form_controller"
application.register("payment-gateway-form", PaymentGatewayFormController)

import PhoneFormattingController from "./phone_formatting_controller"
application.register("phone-formatting", PhoneFormattingController)

import PoCreateConfirmController from "./po_create_confirm_controller"
application.register("po-create-confirm", PoCreateConfirmController)

import PoFamilyGuardController from "./po_family_guard_controller"
application.register("po-family-guard", PoFamilyGuardController)

import PoPollController from "./po_poll_controller"
application.register("po-poll", PoPollController)

import PoPreviewController from "./po_preview_controller"
application.register("po-preview", PoPreviewController)

import PoRemapConfirmController from "./po_remap_confirm_controller"
application.register("po-remap-confirm", PoRemapConfirmController)

import PoRowController from "./po_row_controller"
application.register("po-row", PoRowController)

import PoSubmitStatusController from "./po_submit_status_controller"
application.register("po-submit-status", PoSubmitStatusController)

import PoTotalsController from "./po_totals_controller"
application.register("po-totals", PoTotalsController)

import PriceListReviewController from "./price_list_review_controller"
application.register("price-list-review", PriceListReviewController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import ProductFormController from "./product_form_controller"
application.register("product-form", ProductFormController)

import ProductGalleryController from "./product_gallery_controller"
application.register("product-gallery", ProductGalleryController)

import ProductPricerController from "./product_pricer_controller"
application.register("product-pricer", ProductPricerController)

import ProductVariantsController from "./product_variants_controller"
application.register("product-variants", ProductVariantsController)

import QuickSupplierController from "./quick_supplier_controller"
application.register("quick-supplier", QuickSupplierController)

import QuotePackagingController from "./quote_packaging_controller"
application.register("quote-packaging", QuotePackagingController)

import QuotePricingController from "./quote_pricing_controller"
application.register("quote-pricing", QuotePricingController)

import ReceiveToggleController from "./receive_toggle_controller"
application.register("receive-toggle", ReceiveToggleController)

import ReloadOnChangeController from "./reload_on_change_controller"
application.register("reload-on-change", ReloadOnChangeController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ScrollToBottomController from "./scroll_to_bottom_controller"
application.register("scroll-to-bottom", ScrollToBottomController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SegmentedRadioController from "./segmented_radio_controller"
application.register("segmented-radio", SegmentedRadioController)

import ShippingCarrierProviderController from "./shipping_carrier_provider_controller"
application.register("shipping-carrier-provider", ShippingCarrierProviderController)

import SimpleOrderWizardController from "./simple_order_wizard_controller"
application.register("simple-order-wizard", SimpleOrderWizardController)

import SmartUploadController from "./smart_upload_controller"
application.register("smart-upload", SmartUploadController)

import StockTransferController from "./stock_transfer_controller"
application.register("stock-transfer", StockTransferController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToolCalculatorController from "./tool_calculator_controller"
application.register("tool-calculator", ToolCalculatorController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TourController from "./tour_controller"
application.register("tour", TourController)

import VariantMatrixController from "./variant_matrix_controller"
application.register("variant-matrix", VariantMatrixController)

import VisibilityModeController from "./visibility_mode_controller"
application.register("visibility-mode", VisibilityModeController)

import WorkspaceTabsController from "./workspace_tabs_controller"
application.register("workspace-tabs", WorkspaceTabsController)
